import { configure } from '@bxp-framework/app';
import * as models from './models';
import { Page, UiAccordion, UiAddToSlackSection, UiBlock, UiButton, UiCarousel, UiColumn, UiCookieBanner, UiCookiePreferences, UiDownloadButton, UiEmailSignup, UiFeatureComparisonTable, UiFooter, UiHeader, UiImage, UiImageList, UiLink, UiLinkBlock, UiLoginContainer, UiMarkdown, UiMarketoForm, UiModal, UiNavImages, UiPlaceholder, UiPowerUp, UiPriceCard, UiPricingCalculator, UiPricingTable, UiRecommendShare, UiRotatingItems, UiSection, UiStack, UiTechDemo, UiTextBlock, UiTooltip, UiTrelloBoard, UiValueProp, UiVideo, UiVideoPlayer, UiWebinarLink } from './views';
export const configuration = configure({
    models,
    views: {
        page: Page,
        uiAccordion: UiAccordion,
        uiAddToSlackSection: UiAddToSlackSection,
        uiBlock: UiBlock,
        uiButton: UiButton,
        uiCarousel: UiCarousel,
        uiColumn: UiColumn,
        uiCookieBanner: UiCookieBanner,
        uiCookiePreferences: UiCookiePreferences,
        uiDownloadButton: UiDownloadButton,
        uiEmailSignup: UiEmailSignup,
        uiFeatureComparisonTable: UiFeatureComparisonTable,
        uiFooter: UiFooter,
        uiHeader: UiHeader,
        uiImage: UiImage,
        uiImageList: UiImageList,
        uiLink: UiLink,
        uiLinkBlock: UiLinkBlock,
        uiLoginContainer: UiLoginContainer,
        uiMarkdown: UiMarkdown,
        uiMarketoForm: UiMarketoForm,
        uiModal: UiModal,
        uiNavImages: UiNavImages,
        uiPlaceholder: UiPlaceholder,
        uiPowerUp: UiPowerUp,
        uiPriceCard: UiPriceCard,
        uiPricingCalculator: UiPricingCalculator,
        uiPricingTable: UiPricingTable,
        uiRecommendShare: UiRecommendShare,
        uiRotatingItems: UiRotatingItems,
        uiSection: UiSection,
        uiStack: UiStack,
        uiTechDemo: UiTechDemo,
        uiTextBlock: UiTextBlock,
        uiTooltip: UiTooltip,
        uiTrelloBoard: UiTrelloBoard,
        uiValueProp: UiValueProp,
        uiVideo: UiVideo,
        uiVideoPlayer: UiVideoPlayer,
        uiWebinarLink: UiWebinarLink
    }
});
//# sourceMappingURL=configuration.js.map